import { Album as DownloadAlbum } from '@bpm-web-app/download-api-sdk';
import { useFeaturedBpmOriginalMedia } from '@bpm-web-app/swr-hooks';
import { useHubSwitch } from '@bpm-web-app/utils';
import { useCallback, useContext, useState } from 'react';

import { MediaWithAlbum, SortByQueryOptions } from '@bpm-web-app/stream-api-sdk';
import { useRouter } from 'next/router';
import { LibraryTabsContext } from '../../../../../utils/src/lib/library-tabs.context';
import styles from './featured-bpm-exclusives-all.module.css';
// eslint-disable-next-line import/no-named-as-default-member
import SeeMoreMobile from '../../see-more-mobile/see-more-mobile';

import SeeMoreSupremeLayout from '../../see-more-layout/see-more-supreme-layout';
import { TrackListSupreme } from '../../shared/track-list/supreme/track-list-supreme';
import { TrackListPresetSupreme } from '../../shared/track-list/supreme/track-list-supreme-helpers';
import { allApiSortOptions } from '../../sort-options-sheet/sort-options-sheet';

export function FeaturedBpmExclusivesAll() {
    const [sortType, setSortType] = useState<SortByQueryOptions>(SortByQueryOptions.DateDesc);
    const { libraryProperty } = useContext(LibraryTabsContext);
    const { data, isLoading } = useFeaturedBpmOriginalMedia({ library: libraryProperty, sort_by: sortType });
    const { isDownload } = useHubSwitch();
    const router = useRouter();

    const searchFeaturedBpmOriginal = data?.data;

    const downloadAlbumsList = searchFeaturedBpmOriginal as DownloadAlbum[];
    const streamMediaList = searchFeaturedBpmOriginal?.slice(0, 100) as MediaWithAlbum[];

    /* Builds one merged query from whichever filters fired and replaces in a single call,
     * rather than one router.replace per filter (each of which would otherwise spread the
     * same stale router.query, silently dropping the others if more than one fires at once). */
    const handleFilterApplied = useCallback((filters: { bpm?: number; key?: string; genre?: string }) => {
        router.replace({
            pathname: router.pathname,
            query: {
                ...router.query,
                ...(filters.bpm && { bpm: [filters.bpm, filters.bpm] }),
                ...(filters.genre && { genre: [filters.genre] }),
                ...(filters.key && { key: [filters.key] }),
            },
        });
    }, [router]);

    return (
        <div className={styles['featured-bpm-exclusives-all']}>
            <SeeMoreSupremeLayout
                pageTitle="Featured Exclusives"
                mobileChildren={<SeeMoreMobile data={isDownload ? downloadAlbumsList : streamMediaList} isDownload={isDownload} contentType={isDownload ? 'download:album' : 'track'} isLoading={isLoading} />}
                desktopChildren={
                    <TrackListSupreme
                        isSortable
                        hasColumnSorting
                        onSort={(nextSort) => setSortType(nextSort as SortByQueryOptions)}
                        sortOptions={allApiSortOptions}
                        selectedSortType={sortType}
                        preset={isDownload ? TrackListPresetSupreme.Download : TrackListPresetSupreme.Stream}
                        list={isDownload ? downloadAlbumsList : streamMediaList}
                        onFilterApplied={handleFilterApplied}
                    />
                }
            />
        </div>
    );
}

export default FeaturedBpmExclusivesAll;
